<template>
  <t-default-entry
    sub-heading="Login"
    heading="初回ログイン"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <div v-if="error" class="t-login-invited-user-password__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <form class="t-login-invited-user-password__form" @submit.prevent="handleFormSubmit">
      <div class="t-login-invited-user-password__group">
        <m-form-input class="t-login-invited-user-password__input" label="ユーザーID">
          <a-text-field :value="email" type="email" name="" placeholder="dummy@gmail.com" :disabled="true" />
        </m-form-input>
        <m-form-input class="t-login-invited-user-password__input" label="ユーザーID">
          <a-text-field :value="name" type="text" name="" :disabled="true" />
        </m-form-input>
        <m-form-input class="t-login-invited-user-password__input" label="パスワード">
          <a-text-field v-model="password" type="password" hidden name="" placeholder="パスワード" />
        </m-form-input>
      </div>
      <m-button-container class="t-login-invited-user-password__buttons">
        <a-button variant="block" submit="submit" color="primary">ログイン</a-button>
        <a-button color="primary" @click="handleNoAccountClick">アカウントをお持ちでない方はこちら</a-button>
      </m-button-container>
    </form>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';

export default {
  name: 't-login-invited-user-password-invited-user-password',
  components: {
    AAlert,
    AButton,
    ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleSubmitForm: {
      type: Function,
      default: () => {},
    },
    handleNoAccountClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      password: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-login-invited-user-password-invited-user-password');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      this.handleSubmitForm({
        password: this.password,
      });
    },
  },
};
</script>
